(function() {
  function toBoolean(value) {
    return String(value) === 'true';
  }

  function initSection(section) {
    window.preselectedMaterial = false;

    if (toBoolean(section.dataset.isFloraScroll) && $(window).width() < 600) {
      $('.templateCollection').addClass('scroll');
      var headerHeightMobile = $('#header').height();
      $('.plp-main-banner').css('padding-top', headerHeightMobile);
    }

    var materialFilter = (section.dataset.materialFilter || '').trim();
    var defaultPreselectedMaterial = (section.dataset.defaultPreselectedMaterial || '').trim();

    if (materialFilter) {
      window.preselectedMaterial = materialFilter;
    } else if (!window.preselectedMaterial && defaultPreselectedMaterial) {
      window.preselectedMaterial = defaultPreselectedMaterial;
    }
  }

  function initPlpAjaxContent() {
    document
      .querySelectorAll('.main-container[data-section-type="plp-ajax-content"]')
      .forEach(initSection);
  }

  window.initPlpAjaxContent = initPlpAjaxContent;

  $(function() {
    initPlpAjaxContent();
  });
})();
